import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Container, Alert, Spinner } from 'react-bootstrap';

const AuthVerification = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyAccount = async () => {
      try {
        const token = searchParams.get('token');
        if (!token) {
          setStatus('error');
          setMessage('Token não encontrado');
          return;
        }

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/auth/verify?token=${token}`);
        setStatus('success');
        setMessage(response.data.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Erro ao verificar a conta');
      }
    };

    verifyAccount();
  }, [searchParams]);

  return (
    <Container className="mt-5">
      {status === 'loading' && (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Carregando...</span>
          </Spinner>
          <p className="mt-2">Verificando sua conta...</p>
        </div>
      )}

      {status === 'success' && (
        <Alert variant="success" className="text-center">
          <h4>Sucesso!</h4>
          <p>{message}</p>
        </Alert>
      )}

      {status === 'error' && (
        <Alert variant="danger" className="text-center">
          <h4>Erro</h4>
          <p>{message}</p>
        </Alert>
      )}
    </Container>
  );
};

export default AuthVerification; 